import { useEffect, useState } from "react";
import {
  graphqlMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";
import {
  notificationsAndCount,
  requestCrbMonthlyReportMutation,
} from "../../../data/Axios/queries";
import {
  notificationservice,
  reportsManagementUrl,
} from "../../../config";
import { useHubEvent } from "../../../context/NotificationHubContext";

const CRB_MONTHLY_REPORT_TYPE = "CrbMonthlyReport";

export const useCrbMonthlyReport = () => {
  const [status, setStatus] = useState("Idle");
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [error, setError] = useState(null);

  // The toast + Topbar-bell refresh for this event live in
  // CrbMonthlyReportGlobalListener (mounted app-wide in App.js) so they fire
  // even when this card isn't on screen. This subscription only keeps the
  // card's own state in sync while it happens to be mounted.
  useHubEvent("ReportReady", (payloadJson) => {
    const payload = JSON.parse(payloadJson);
    setStatus(payload.status);
    setDownloadUrl(payload.downloadUrl || null);
  });

  useEffect(() => {
    let isMounted = true;

    async function catchUpFromNotifications() {
      try {
        const data = await graphqlQuery(
          notificationsAndCount,
          notificationservice.uri
        );
        const crbNotifications = (data?.notifications || [])
          .filter(
            (notification) =>
              notification.notificationType === CRB_MONTHLY_REPORT_TYPE
          )
          .sort(
            (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
          );

        if (isMounted && crbNotifications.length > 0) {
          const payload = JSON.parse(crbNotifications[0].body);
          setStatus(payload.status);
          setDownloadUrl(payload.downloadUrl || null);
        }
      } catch (err) {
        console.error("Error fetching CRB monthly report notifications:", err);
      }
    }

    catchUpFromNotifications();
    return () => {
      isMounted = false;
    };
  }, []);

  const requestReport = async (startDate, endDate, whereClause) => {
    setError(null);
    try {
      const data = await graphqlMutation(
        requestCrbMonthlyReportMutation(startDate, endDate, whereClause),
        reportsManagementUrl.uri
      );
      const { results, error: mutationError } = data.requestCrbMonthlyReport;

      if (mutationError) {
        setError(JSON.parse(mutationError));
        return;
      }

      const payload = JSON.parse(results);
      setStatus(payload.status);
    } catch (err) {
      console.error("Error requesting CRB monthly report:", err);
      setError(err.message || "An unexpected error occurred.");
    }
  };

  return { status, downloadUrl, error, requestReport };
};
